import { useEffect, useState } from 'react';
import './file.css'
import { Button } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { GeneralFetch } from 'Api/generalFetch/generalFetch';
import { useRecoilValue } from 'recoil';
import { DrawerSchema } from 'schemas';

export default function FileInput({ setLoading, setRefetch, refetch, showUploadBtn = true, setFormData = (e) => { } }) {
    const [files, setFiles] = useState([]);
    const { fetchData, loading } = GeneralFetch()
    const object = useRecoilValue(DrawerSchema)

    useEffect(() => {
        showUploadBtn && setLoading(loading)
    }, [loading])

    const handleFileChange = (e) => {
        setFiles([...e.target.files]);
        setFormData((prev) => ({ ...prev, evidencias: [...e.target.files] }))
    };

    const handleUpload = async () => {
        if (files.length === 0) return alert("Please select images first!");

        const formData = new FormData();
        files.forEach(file => formData.append("evidencias[]", file));
        const obj = object.object === 'nearmisses' ? 'nearmiss' : "incidente"

        try {
            formData.append('object_id', object?.data?.objectId)
            formData.append('object', obj)
            formData.append('boapratica', object.object === 'boaspraticas')

            await fetchData(formData, 'upload', 'POST', '').then((result) => {
                setFiles([])
                setRefetch(!refetch)
            }).catch((err) => {
                setFiles([])
            });

        } catch (error) {
            console.error("Upload failed", error);
        }
    };

    return (
        <>
            {files.length > 0 ?
                <div style={{ margin: "5px 5px 5px 8px" }} >
                    <span style={{ fontSize: "15px", letterSpacing: "2px", fontWeight: "500" }} >{files.length} Foto(s)</span>  {showUploadBtn && <Button onClick={() => handleUpload()} variant="contained" style={{ color: "#fff", width: "100px", padding: "0px", background: "#58A4B0" }} size='small' startIcon={<FileUploadIcon />} ><span style={{ letterSpacing: "2px", textTransform: "capitalize" }} >Upload</span></Button>}
                </div>
                :
                <input type="file" style={{ margin: "0 0 3px 3px" }} accept='.jpeg,.jpg,.png' multiple onChange={handleFileChange} />
            }
        </>
    )
}